// extracted by mini-css-extract-plugin
export default {"buttons":"CancelPurchaseButton_buttons__MonQu"};